module.exports = __webpack_public_path__ + "static/img/gen_root1.1fefa3f5.jpg";